<template>
  <article class="trust-teaser-app-review flex flex-col p-200 rounded-m mr-100">
    <header>
      <LcRating v-bind="{ rating }" />
    </header>

    <p class="review flex-grow my-100">{{ review }}</p>

    <footer class="flex justify-between paragraph-small-text">
      <div class="flex gap-100">
        <span>{{ username }}</span>
        <span class="store">{{ store }}</span>
      </div>

      <span v-if="date" class="text-capitalize">
        {{ formatDate(date, 'date', undefined, locale) }}
      </span>
    </footer>
  </article>
</template>

<script lang="ts" setup>
export type TrustTeaserCardAppReviewProps = {
  date?: Maybe<string>
  rating: number
  review: string
  store: string
  username: string
}

defineProps<TrustTeaserCardAppReviewProps>()

const { locale } = useI18n()
</script>

<style lang="scss" scoped>
.trust-teaser-app-review {
  min-width: 19.5rem;
  max-width: 19.5rem;
  height: 7.5rem;
  border: token('size/border/100') solid token('color/border/primary/primary');
  background-color: token('color/background/secondary/secondary');

  .review {
    @include truncate;
  }

  .store {
    color: token('color/text/secondary/secondary');
  }
}
</style>
